import { Box, Typography } from "@mui/material";
import Images from "../../../assets";
import React from "react";

export default function Footer() {
    return (
        <Box
            sx={{
                width: "100%",
                borderTop: "2px solid #004B88",
                mt: 10,
                py: 3,
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                justifyContent: { xs: "center", md: "space-between" },
                alignItems: "center",
                textAlign: { xs: "center", md: "left" },
                gap: { xs: 2, md: 0 },
                maxWidth: 1440,
                mx: "auto",
                px: { xs: 2, md: 4 },
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flexDirection: { xs: "column", md: "row" },
                }}
            >
                <Box
                    component="img"
                    src={Images.bigLogoNew}
                    alt="logo"
                    sx={{
                        display:'flex',
                        width: "90%",
                        height:'70%'
                    }}
                />
                {/*<Typography sx={{ fontSize: 11, color: "#004B88", lineHeight: 1.3 }}>*/}
                {/*    ΙΔΡΥΜΑ ΣΤΑΥΡΟΣ ΝΙΑΡΧΟΣ<br />*/}
                {/*    STAVROS NIARCHOS FOUNDATION*/}
                {/*</Typography>*/}
            </Box>


            <Typography sx={{ fontSize: 11, color: "#004B88" }}>
                ©2025, Stavros S. Niarchos Foundation for Charity
            </Typography>
        </Box>
    );
}
